import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdUploadComponent } from './ad-upload.component';
import { FileUploadModule } from 'ng2-file-upload';
import { AdButtonModule } from '../ad-button/ad-button.module';
import { AdLineLoadingModule } from '../ad-line-loading/ad-line-loading.module';

@NgModule({
  declarations: [AdUploadComponent],
  imports: [
    CommonModule,
    FileUploadModule,
    AdButtonModule,
    AdLineLoadingModule,
    FormsModule
  ],
  exports: [AdUploadComponent]
})
export class AdUploadModule {}

export * from './ad-upload.component';
